const MappedContacts = ({ moduleLookupData }) => {

    let tableColumn = ["Contact Name", "Email", "Phone", "Mobile", "Contact Owner"];

    return (
        <>
            <div className="bg-white border rounded-lg shadow-sm mt-1 rounded">
                <div className="col-md-12">
                    <div className="tbl-container rounded-table overflow-y-auto" style={{ maxHeight: 'calc(100vh - 21.2vh)' }}>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <thead>
                                    <tr>
                                        {tableColumn.map((data) => (
                                            <th key={data}>{data}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {moduleLookupData?.Contacts && moduleLookupData?.Contacts.length > 0 ? (
                                        moduleLookupData?.Contacts.map((contact) => (
                                            <tr key={contact?._id}>
                                                <td>{contact?.data?.section_data?.First_Name} {contact?.data?.section_data?.Last_Name}</td>
                                                <td>{contact?.data?.section_data?.Email}</td>
                                                <td>{contact?.data?.section_data?.Phone}</td>
                                                <td>{contact?.data?.section_data?.Mobile}</td>
                                                <td>{contact?.data?.section_data?.Contact_Owner?.name}</td>
                                            </tr>
                                        ))
                                    ) :
                                        <td colSpan="6" className="text-center">No records found</td>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MappedContacts;